import React, {Component, ReactElement, ReactNode, RefObject} from 'react'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import {
    INFOMATION_TYPE,
    MANAGEMENT_CATEGORY,
    MANSION_CATEGORY,
    MESSAGE_TYPE,
    ROLE_FOR_ADMINISTRATOR,
    VISITORS_RANGE,
} from '../../../CodeMaster'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import {NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime'
import {Messages} from '../../../Messages'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink, StyledLink} from '../../../styledComponents/adminPage/Links'
import {StyledTableCaption, TableRowName} from '../../../styledComponents/adminPage/Table'
import PPSelect, {OptionProps} from '../../../components/shared/forms/PPSelect'
import PPTextField from '../../../components/shared/forms/PPTextField'
import PPRadioGroup, {PPRadioItemProp} from '../../../components/shared/forms/PPRadioGroup'
import PPDatePicker from '../../../components/shared/forms/PPDatePicker'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {getYearAfterNextDate, getYearDate, openPdfPreviewWindow} from '../../common/util/Natutil'
import PPInput from '../../../components/shared/forms/PPInput'
import PPNumericField from '../../../components/shared/forms/PPNumericField'
import NatApartAssocInfoRepo from './repository/NatApartAssocInfoRepo'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {NatGetApartAssocInfo} from './repository/NatGetApartAssocInfo'
import {NatPutApartAssocInfo, NatPutApartAssocInfoParams, PublishMaterialInfo} from './repository/NatPutApartAssocInfo'
import {formatForDateInput} from '../../../formatters/formatDate'
import {StyledDiv, StyledLabel, StyledSpan} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {
    FlexStartRowFlexContainer,
    LeftRowFlexContainer,
    RowFlexContainer,
} from '../../../styledComponents/FlexComponents'
import {isIE} from 'react-device-detect'
import PPFileInput from '../../../components/shared/forms/PPFileInput'
import {Location} from 'react-router-dom'

import {Link, Table, TableBody, TableCell, TableRow} from '@mui/material';
import {SelectChangeEvent} from '@mui/material/Select'

const KEY_LOGIN_USER_ROLE_ID: string = 'loginUserRoleId'

interface Props {
    apartAssocId: string
    apartAssocInfoRepo: NatApartAssocInfoRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    title: string
    infoCategoryId: string
    categoryId: string
    sortOrder: string
    publishStartDate: string
    publishEndDate: string
    publishStartDateMin: string
    publishStartDateMax: string
    publishEndDateMin: string
    publishEndDateMax: string
    browseAuthority: string
    apartAssocFileList: CustomPublishMaterialInfo[]
    fileName: string
    publishMaterialName: string
    fileData: string | ArrayBuffer | null
    fileSize: number
    addMessageFileButtonDisabled: boolean
    version: string
    isLoadCompleted: boolean
    selectedMaxDateTime: string
    fileInputDisabled: boolean
}

interface CustomPublishMaterialInfo extends PublishMaterialInfo {
    registeredFlag: boolean
    deleteFlag: boolean
}

class NatAdminApartAssocInfoEditPage extends Component<Props & AdminPagePropsSet, States> {
    messageFile: RefObject<HTMLInputElement>
    roleId: Nullable<string>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)


        // 管理組合役員の場合、情報種別は固定
        this.roleId = SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_USER_ROLE_ID)
        let selectedInfomationType: string = ''
        if (this.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value) {
            selectedInfomationType = INFOMATION_TYPE.ASSOC_INFO.value
        }

        this.state = {
            title: '',
            infoCategoryId: selectedInfomationType,
            categoryId: '',
            sortOrder: '',
            publishStartDate: '',
            publishEndDate: '',
            publishStartDateMin: '',
            publishStartDateMax: '',
            publishEndDateMin: '',
            publishEndDateMax: '',
            browseAuthority: VISITORS_RANGE.ALL.value,
            apartAssocFileList: [],
            fileName: '',
            publishMaterialName: '',
            fileData: '',
            fileSize: 0,
            addMessageFileButtonDisabled: true,
            version: '',
            isLoadCompleted: false,
            selectedMaxDateTime: '',
            fileInputDisabled: false,
        }
        this.messageFile = React.createRef()

        this.handleRegisterOkClick = this.handleRegisterOkClick.bind(this)
        this.handleRegisterCancelClick = this.handleRegisterCancelClick.bind(this)
        this.onChangeInformation = this.onChangeInformation.bind(this)
        this.onChangeCategory = this.onChangeCategory.bind(this)
        this.onChangeTitle = this.onChangeTitle.bind(this)
        this.onChangePublishStartDate = this.onChangePublishStartDate.bind(this)
        this.onChangePublishEndDate = this.onChangePublishEndDate.bind(this)
        this.onChangeSortOrder = this.onChangeSortOrder.bind(this)
        this.onChangeVisitors = this.onChangeVisitors.bind(this)
        this.onChangePublishMaterialName = this.onChangePublishMaterialName.bind(this)
        this.onChangeFile = this.onChangeFile.bind(this)
        this.changeMessageFileSortOrder = this.changeMessageFileSortOrder.bind(this)
        this.addApartAssocFile = this.addApartAssocFile.bind(this)
        this.deleteApartAssocFile = this.deleteApartAssocFile.bind(this)
        this.getCategoryList = this.getCategoryList.bind(this)
        this.registerApartAssocButton = this.registerApartAssocButton.bind(this)
        this.judgregisterApartAssocButton = this.judgregisterApartAssocButton.bind(this)
        this.changeMessageFilePublishName = this.changeMessageFilePublishName.bind(this)
        this.validApartAssocFileCount = this.validApartAssocFileCount.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // 現在日時
            const currentDateTime: Nullable<NatGetCurrentDateTime> = await this.props.asyncCallFunction(
                this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            let yearAfterNext: string = ''
            if (currentDateTime && currentDateTime.details) {
                yearAfterNext = getYearAfterNextDate(currentDateTime.details.currentDateTime)
                this.setState({
                    selectedMaxDateTime: yearAfterNext,
                    publishStartDateMin: getYearDate(),
                    publishStartDateMax: yearAfterNext,
                    publishEndDateMin: getYearDate(),
                    publishEndDateMax: yearAfterNext,
                })
            }
            const apartAssoc: Nullable<NatGetApartAssocInfo> = await this.props.asyncCallFunction(
                this.props.apartAssocInfoRepo.getApartAssocInfo.bind(
                    this.props.apartAssocInfoRepo, this.props.apartAssocId),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (apartAssoc && apartAssoc.details) {
                const apartAssocFileList: CustomPublishMaterialInfo[] = []
                if (apartAssoc.details.publishMaterialInfo) {
                    apartAssoc.details.publishMaterialInfo.forEach((file, index) => {
                        const apartAssocFile: CustomPublishMaterialInfo = {
                            fileNumber: file.fileNumber,
                            sortOrder: file.sortOrder,
                            publishMaterialName: file.publishMaterialName,
                            path: file.path,
                            registeredFlag: true,
                            deleteFlag: false,
                        }
                        apartAssocFileList.push(apartAssocFile)
                    })
                }
                this.setState({
                    title: apartAssoc.details.title,
                    infoCategoryId: apartAssoc.details.infoCategoryId,
                    categoryId: apartAssoc.details.categoryId,
                    sortOrder: String(apartAssoc.details.sortOrder),
                    publishStartDate: apartAssoc.details.publishStartDate,
                    publishEndDate: apartAssoc.details.publishEndDate ?? '',
                    publishStartDateMax: apartAssoc.details.publishEndDate ?? yearAfterNext,
                    publishEndDateMin: apartAssoc.details.publishStartDate,
                    browseAuthority: apartAssoc.details.browseAuthority,
                    apartAssocFileList: apartAssocFileList,
                    version: apartAssoc.details.version,
                    isLoadCompleted: true,
                    fileInputDisabled: false,
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    onChangeInformation(event: SelectChangeEvent<unknown>): void {
        this.setState({
            infoCategoryId: event.target.value as string,
            categoryId: '',
        })
    }

    onChangeCategory(event: SelectChangeEvent<unknown>): void {
        this.setState({categoryId: event.target.value as string})
    }

    onChangeTitle(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({title: event.target.value})
    }

    onChangePublishStartDate(date: Nullable<Date>): void {
        if (date !== null) {
            this.setState({publishStartDate: date.toString(), publishEndDateMin: date.toString()})
        } else {
            this.setState({publishStartDate: '', publishEndDateMin: getYearDate()})
        }
    }

    onChangePublishEndDate(date: Nullable<Date>): void {
        if (date !== null) {
            this.setState({publishEndDate: date.toString(), publishStartDateMax: date.toString()})
        } else {
            this.setState({publishEndDate: '', publishStartDateMax: this.state.selectedMaxDateTime})
        }
    }

    onChangeSortOrder(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({sortOrder: event.target.value})
    }

    onChangeVisitors(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({browseAuthority: event.target.value})
    }

    onChangePublishMaterialName(event: React.ChangeEvent<HTMLInputElement>): void {
        if (event.target.value && this.state.fileName) {
            this.setState({addMessageFileButtonDisabled: false})
        } else {
            this.setState({addMessageFileButtonDisabled: true})
        }
        this.setState({publishMaterialName: event.target.value})
    }

    onChangeFile(event: React.ChangeEvent<HTMLInputElement>): void {
        // ファイル情報取得
        if (event.target.files && event.target.files[0] && event.target.files[0].name) {
            if (this.state.publishMaterialName) {
                this.setState({addMessageFileButtonDisabled: false})
            } else {
                this.setState({addMessageFileButtonDisabled: true})
            }
            this.setState({
                fileName: event.target.files[0].name,
                fileSize: event.target.files[0].size,
            })
            const reader: FileReader = new FileReader()
            reader.onload = () => {
                this.setState({fileData: reader.result})
            }
            reader.readAsDataURL(event.target.files[0])
        } else {
            this.setState({
                fileName: '',
                fileData: '',
                fileSize: 0,
                addMessageFileButtonDisabled: true,
            })
        }
    }

    changeMessageFilePublishName(event: React.ChangeEvent<HTMLInputElement>): void {
        const apartAssocFileList = this.state.apartAssocFileList
        apartAssocFileList[Number(event.target.name)].publishMaterialName = event.target.value
        this.setState({apartAssocFileList: apartAssocFileList})
    }

    changeMessageFileSortOrder(event: React.ChangeEvent<HTMLInputElement>): void {
        const apartAssocFileList = this.state.apartAssocFileList
        apartAssocFileList[Number(event.target.name)].sortOrder = Number(event.target.value)
        this.setState({apartAssocFileList: apartAssocFileList})
    }

    validApartAssocFileCount(): number {
        const apartAssocFileList = this.state.apartAssocFileList
        const validApartAssocFileCount = apartAssocFileList.filter(file => file.deleteFlag === false).length
        return validApartAssocFileCount
    }

    addApartAssocFile(): void {
        const apartAssocFileList = this.state.apartAssocFileList
        const validApartAssocFileList = apartAssocFileList.filter(file => file.deleteFlag === false)
        const addFileList = validApartAssocFileList.filter(file => file.registeredFlag === false)
        const apartAssocFile: CustomPublishMaterialInfo = {
            ['sortOrder']: validApartAssocFileList.length + 1,
            ['fileName']: this.state.fileName,
            ['fileSize']: this.state.fileSize,
            ['fileData']: this.state.fileData,
            ['publishMaterialName']: this.state.publishMaterialName,
            ['registeredFlag']: false,
            ['deleteFlag']: false,
        }
        apartAssocFileList.push(apartAssocFile)
        this.setState({
            fileName: '',
            fileSize: 0,
            fileData: '',
            publishMaterialName: '',
            addMessageFileButtonDisabled: true,
            apartAssocFileList: apartAssocFileList,
            fileInputDisabled: (addFileList.length + 1 >= 3),
        })
        // 追加したタイミングで選択したファイルをクリア
        if (this.messageFile.current && this.messageFile.current.value) {
            this.messageFile.current.value = ''
        }
    }

    deleteApartAssocFile(index: number): void {
        const apartAssocFileList = this.state.apartAssocFileList
        apartAssocFileList[index].deleteFlag = true
        apartAssocFileList[index].fileData = null
        const addFileCount = apartAssocFileList.filter(file => file.registeredFlag === false
            && file.deleteFlag === false)
        this.setState({
            apartAssocFileList: apartAssocFileList,
            fileInputDisabled: (addFileCount.length >= 3),
        })
    }

    previewApartAssocFile(dataUri: string): void {
        const data: string[] = dataUri.split(',')
        if (data[1]) {
            openPdfPreviewWindow(data[1])
        }
    }

    handleRegisterCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleRegisterOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()
        try {
            const apartAssocFileList: PublishMaterialInfo[] = []
            if (this.state.apartAssocFileList) {
                this.state.apartAssocFileList.forEach((file, index) => {
                    const fileData: string[] = String(file.fileData).split(',')
                    if (file.deleteFlag === true) {
                        return
                    }
                    if (fileData[1]) {
                        let apartAssocFile: PublishMaterialInfo
                        if (file.fileNumber) {
                            apartAssocFile = {
                                fileNumber: file.fileNumber,
                                sortOrder: file.sortOrder,
                                publishMaterialName: file.publishMaterialName,
                                fileName: file.fileName,
                                fileData: fileData[1],
                                fileSize: file.fileSize,
                                fileIndex: index,
                            }
                        } else {
                            apartAssocFile = {
                                sortOrder: file.sortOrder,
                                publishMaterialName: file.publishMaterialName,
                                fileName: file.fileName,
                                fileData: fileData[1],
                                fileSize: file.fileSize,
                                fileIndex: index,
                            }
                        }
                        apartAssocFileList.push(apartAssocFile)
                    } else {
                        apartAssocFileList.push(file)
                    }
                })
            }
            const request: NatPutApartAssocInfoParams = {
                apartAssocInfoId: this.props.apartAssocId,
                title: this.state.title,
                infoCategoryId: this.state.infoCategoryId,
                categoryId: this.state.categoryId,
                sortOrder: this.state.sortOrder,
                publishStartDate: this.state.publishStartDate ? formatForDateInput(this.state.publishStartDate) : '',
                publishEndDate: this.state.publishEndDate ? formatForDateInput(this.state.publishEndDate) : '',
                browseAuthority: this.state.browseAuthority,
                version: this.state.version,
                publishMaterialInfo: apartAssocFileList,
            }
            const putApartAssocInfo: Nullable<NatPutApartAssocInfo> = await this.props.asyncCallFunction(
                this.props.apartAssocInfoRepo.putUpdateApartAssocInfo.bind(this.props.apartAssocInfoRepo, request),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
                {defaultErrorTitle: Messages.EOPCA0002.toString('マンション・組合情報')},
            )
            if (putApartAssocInfo && putApartAssocInfo.requestError === null) {
                this.props.navigate(`/admin/apartAssoc/${this.props.apartAssocId}`,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IOPCC0005.toString('マンション・管理組合情報', this.state.title),
                            },
                        },
                    },
                )
            }

        } finally {
            this.props.eventEmitter.closeLoading()
        }

    }

    getInformationCategoryList(): OptionProps[] {
        let informations: OptionProps[]

        informations = INFOMATION_TYPE.values().map((information) => {
            return ({
                label: `${information.label}`,
                value: `${information.value}`,
            })
        })

        return [{
            label: '情報種別を選択してください',
            value: '',
        }, ...informations]
    }

    getCategoryList(informationCategoryId: string): OptionProps[] {
        let categories: OptionProps[] = []

        switch (informationCategoryId) {
            case INFOMATION_TYPE.APART_INFO.value:
                categories = MANSION_CATEGORY.values().map((item) => {
                    return ({
                        label: `${item.label}`,
                        value: `${item.value}`,
                    })
                })
                break
            case INFOMATION_TYPE.ASSOC_INFO.value:
                categories = MANAGEMENT_CATEGORY.values().map((item) => {
                    return ({
                        label: `${item.label}`,
                        value: `${item.value}`,
                    })
                })
                break
            default:
                break
        }

        return [{
            label: 'カテゴリを選択してください',
            value: '',
        }, ...categories]
    }

    // ターゲット属性
    getVisitorsRadioGroupData(): PPRadioItemProp[] {
        const visitorsRadioGroupData: PPRadioItemProp[] = []
        VISITORS_RANGE.values().map((visitors) => (
            visitorsRadioGroupData.push(
                {
                    label: visitors.label,
                    value: visitors.value,
                    radioProps: {
                        checked: visitors.value === this.state.browseAuthority,
                        onChange: this.onChangeVisitors,
                    },
                },
            )
        ))
        return visitorsRadioGroupData
    }

    async registerApartAssocButton(): Promise<void> {
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0010.errorLevel,
                message: Messages.IOPCC0010.toString('マンション・管理組合情報'),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleRegisterCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleRegisterOkClick,
                    },
                ],
            },
        )
    }

    judgregisterApartAssocButton(): boolean {
        const validApartAssocFileList = this.state.apartAssocFileList.filter(file => file.deleteFlag === false)
        return !(this.state.infoCategoryId !== '' &&
            this.state.categoryId !== '' &&
            this.state.title !== '' &&
            this.state.publishStartDate !== '' &&
            this.state.browseAuthority !== '' &&
            validApartAssocFileList.length !== 0
        )
    }

    renderEventFormTable(): ReactNode {
        return (
            <>
                <Table>
                    <StyledTableCaption>マンション・管理組合情報</StyledTableCaption>
                    <TableBody>
                        {this.roleId !== ROLE_FOR_ADMINISTRATOR.ASSOC.value &&
                            <TableRow>
                                <TableRowName required>情報種別</TableRowName>
                                <TableCell colSpan={4}>
                                    <PPSelect
                                        autoFocus
                                        data={this.getInformationCategoryList()}
                                        onChange={this.onChangeInformation}
                                        eventKeys={['infoCategoryId']}
                                        eventEmitter={this.props.eventEmitter}
                                        value={this.state.infoCategoryId}
                                    />
                                </TableCell>
                            </TableRow>
                        }
                        <TableRow>
                            <TableRowName required>カテゴリ</TableRowName>
                            <TableCell colSpan={4}>
                                <PPSelect
                                    data={this.getCategoryList(this.state.infoCategoryId)}
                                    onChange={this.onChangeCategory}
                                    eventKeys={['categoryId']}
                                    eventEmitter={this.props.eventEmitter}
                                    value={this.state.categoryId}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required>タイトル</TableRowName>
                            <TableCell colSpan={4}>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 50,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    value={this.state.title}
                                    onChange={this.onChangeTitle}
                                    eventKeys={['title']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required>掲載開始日</TableRowName>
                            <TableCell colSpan={4}>
                                <LeftRowFlexContainer>
                                    <TermWrapper>
                                        <FlexBasis style={{paddingBottom: 4.5, paddingTop: 7.7}}>
                                            <PPDatePicker
                                                onChangeDate={this.onChangePublishStartDate}
                                                value={(this.state.publishStartDate) ?
                                                    new Date(this.state.publishStartDate) : null
                                                }
                                                minDate={(this.state.publishStartDateMin) ?
                                                    new Date(this.state.publishStartDateMin) : undefined
                                                }
                                                maxDate={(this.state.publishStartDateMax) ?
                                                    new Date(this.state.publishStartDateMax) : undefined
                                                }
                                                eventEmitter={this.props.eventEmitter}
                                                eventKeys={['publishStartDate']}
                                            />
                                        </FlexBasis>
                                    </TermWrapper>
                                </LeftRowFlexContainer>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>掲載終了日</TableRowName>
                            <TableCell colSpan={4}>
                                <LeftRowFlexContainer>
                                    <TermWrapper>
                                        <FlexBasis style={{paddingBottom: 4.5, paddingTop: 7.7}}>
                                            <PPDatePicker
                                                onChangeDate={this.onChangePublishEndDate}
                                                value={(this.state.publishEndDate) ?
                                                    new Date(this.state.publishEndDate) : null
                                                }
                                                minDate={(this.state.publishEndDateMin) ?
                                                    new Date(this.state.publishEndDateMin) : undefined
                                                }
                                                maxDate={(this.state.publishEndDateMax) ?
                                                    new Date(this.state.publishEndDateMax) : undefined
                                                }
                                                eventEmitter={this.props.eventEmitter}
                                                eventKeys={['publishEndDate']}
                                            />
                                        </FlexBasis>
                                    </TermWrapper>
                                </LeftRowFlexContainer>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>並び順</TableRowName>
                            <TableCell colSpan={4}>
                                <PPNumericField
                                    InputProps={{
                                        inputProps: {
                                            min: 1,
                                            max: 999,
                                        },
                                    }}
                                    placeholder={'999'}
                                    onChange={this.onChangeSortOrder}
                                    value={this.state.sortOrder}
                                    eventKeys={['sortOrder']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required>閲覧者</TableRowName>
                            <TableCell colSpan={4}>
                                <PPRadioGroup
                                    row
                                    data={this.getVisitorsRadioGroupData()}
                                    eventKeys={['browseAuthority']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName
                                {...{
                                    rowSpan: this.validApartAssocFileCount() !== 0 ?
                                        this.validApartAssocFileCount() + 1 : 1,
                                }} required
                            >掲載資料</TableRowName>
                            <TableCell colSpan={4}>
                                <FlexStartRowFlexContainer>
                                    <DocumentNameWrapper>
                                        <TableCellLabelNoLeftPadding>掲載資料名</TableCellLabelNoLeftPadding>
                                        <PPTextField
                                            InputProps={{
                                                inputProps: {
                                                    id: 'publishMaterialName',
                                                    maxLength: 50,
                                                },
                                            }}
                                            required
                                            fullWidth
                                            onChange={this.onChangePublishMaterialName}
                                            eventKeys={['publishMaterialInfo']}
                                            value={this.state.publishMaterialName}
                                            eventEmitter={this.props.eventEmitter}
                                            disabled={this.state.fileInputDisabled}
                                        />
                                    </DocumentNameWrapper>
                                    <DocumentWrapper>
                                        <DocumentFormWrapper>
                                            <PPFileInput
                                                InputProps={{
                                                    inputProps: {
                                                        id: 'messageFile',
                                                        name: 'messageFile',
                                                    },
                                                }}
                                                fullWidth
                                                inputRef={this.messageFile}
                                                onChange={this.onChangeFile}
                                                fileName={this.state.fileName}
                                                eventKeys={['messageFile']}
                                                eventEmitter={this.props.eventEmitter}
                                                disabled={this.state.fileInputDisabled}
                                            />
                                        </DocumentFormWrapper>
                                        <div style={{color: 'red', flex: '1 0 auto'}}>※5MBまで</div>
                                    </DocumentWrapper>
                                    <DocumentAddButtonWrapper>
                                        <AdminPrimaryButton
                                            onClick={this.addApartAssocFile.bind(this)}
                                            disabled={this.state.addMessageFileButtonDisabled
                                                || this.state.fileInputDisabled}
                                        >PDFを追加
                                        </AdminPrimaryButton>
                                    </DocumentAddButtonWrapper>
                                </FlexStartRowFlexContainer>
                            </TableCell>
                        </TableRow>
                        {this.renderFileArea()}
                    </TableBody>
                </Table>
            </>
        )
    }

    renderFileArea(): ReactNode {
        return <>
            {this.state.apartAssocFileList.map((apartAssocFile, index) => (
                (apartAssocFile.deleteFlag === false) ?
                    <TableRow key={index}>
                        <TableCell colSpan={3}>
                            <RowFlexContainer>
                                <AlreadyDocumentWrapper>
                                    <TableCellLabelNoLeftPadding>
                                        {(apartAssocFile.fileData) ?
                                            <a href="javascript:void(0)"
                                               onClick={(event: React.MouseEvent<HTMLElement>) => {
                                                   event.preventDefault()
                                                   this.previewApartAssocFile(apartAssocFile.fileData as string)
                                               }}>
                                                <img
                                                    src={
                                                        `/resources/images/icons/icon_pdf.png`
                                                    }
                                                    alt=""/>
                                            </a> : (isIE) ?
                                                <Link
                                                    onClick={() => window.open(apartAssocFile.path)}
                                                    target={'_blank'}
                                                    underline="hover">
                                                    <img
                                                        src={
                                                            `/resources/images/icons/icon_pdf.png`
                                                        }
                                                        alt=""
                                                    />
                                                </Link> :
                                                <Link href={apartAssocFile.path} target={'_blank'} underline="hover">
                                                    <img
                                                        src={
                                                            `/resources/images/icons/icon_pdf.png`
                                                        }
                                                        alt=""
                                                    />
                                                </Link>
                                        }
                                    </TableCellLabelNoLeftPadding>
                                    <PPInput
                                        type="text"
                                        inputProps={{
                                            maxLength: 50,
                                        }}
                                        name={String(index)}
                                        value={apartAssocFile.publishMaterialName}
                                        eventKeys={[`publishMaterialInfo[${index}].publishMaterialName`]}
                                        onChange={this.changeMessageFilePublishName.bind(this)}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </AlreadyDocumentWrapper>
                                <TableCellLabelNoLeftPadding>
                                    並び順
                                </TableCellLabelNoLeftPadding>
                                <OrderWrapper>
                                    <DocumentFormWrapper>
                                        <PPNumericField
                                            InputProps={{
                                                inputProps: {
                                                    min: 1,
                                                    max: 999,
                                                },
                                            }}
                                            fullWidth
                                            name={String(index)}
                                            onChange={this.changeMessageFileSortOrder.bind(this)}
                                            value={apartAssocFile.sortOrder}
                                        />
                                    </DocumentFormWrapper>
                                </OrderWrapper>
                                <AlreadyDocumentWrapper>
                                    <TableCellLabelNoLeftPadding>
                                        <StyledLink onClick={() => this.deleteApartAssocFile(index)}>
                                            削除
                                        </StyledLink>
                                    </TableCellLabelNoLeftPadding>
                                </AlreadyDocumentWrapper>
                            </RowFlexContainer>
                        </TableCell>
                    </TableRow> : null
            ))
            }
        </>
    }

    renderPageFooterArea(): ReactNode {

        return (
            <>
                <PageFotterAreaRight>
                    <AdminPrimaryButton
                        disabled={this.judgregisterApartAssocButton()}
                        onClick={this.registerApartAssocButton}
                    >
                        登録
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={() => this.props.navigate(
                            `/admin/apartAssoc/${this.props.apartAssocId}`,
                        )}
                    >
                        マンション・管理組合情報詳細へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>

                <PageMainArea>
                    <form>
                        {this.renderEventFormTable()}
                    </form>
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>

        )
    }
}

const TermWrapper: StyledDiv = styled.div`
  display: flex;
  flex: 1 1 auto;
  justify-items: center;
  align-items: center;
  max-width: 35%;
`

const TermTxt: StyledSpan = styled.span`
  padding: 0 5px 0 5px;
`

const DocumentNameWrapper: StyledDiv = styled.div`
  display: flex;
  flex: 1 1 auto;
  align-items: flex-end;
  padding-right: 15px;
`

const DocumentWrapper = styled(DocumentNameWrapper)`
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-right: 15px;
  max-width: 40%;
`

const AlreadyDocumentWrapper = styled(DocumentNameWrapper)`
  flex: 1 1 0%;
  align-items: center;
`

const OrderWrapper = styled(AlreadyDocumentWrapper)`
  max-width: 10%;
`

const DocumentFormWrapper: StyledDiv = styled.div`
  flex: 1 0 auto;
  width: 100%;
`

const DocumentAddButtonWrapper: StyledDiv = styled.div`
  flex: 0 0 auto;
`

const TableCellLabelNoLeftPadding: StyledLabel = styled.label`
  padding: 0 10px 0 0;
`

const FlexBasis: StyledDiv = styled.div`
  flex: 1 1 0%;
`

export default createAdminPage(NatAdminApartAssocInfoEditPage)
